<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Add Fund</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="newFundDetails" autocomplete="off">
    
    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">Description</label>
      <div class="col-sm-9">
        <textarea class="form-control" 
                  formControlName="description"
                  rows="3"></textarea>
      </div>
    </div>

    <div class="mb-3 row">
      <label class="col-sm-3 col-form-label">Value</label>
      <div class="col-sm-9">
        <div class="input-group">
          <span class="input-group-text">£</span>
          <input type="number" 
                 class="form-control" 
                 formControlName="net">
        </div>
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">
  <button type="button" 
          class="btn btn-success" 
          (click)="addFund()" 
          [disabled]="newFundDetails.invalid">
    Add
  </button>
</div>